import { socketInstance } from "../socket/socket";
import { MessageListRes } from "../types/MessageListType";
import { socketQuery } from "./socketQueries";

export type FetchChatMessagesParams = {
  chat_id: number;
  user_id?: number;
  pinned?: boolean;
  page?: number;
  pageSize?: number;
  around_message_id?: number;
  before?: number;
  after?: number;
  before_message_id?: number;
  after_message_id?: number;
  /** Fill hole exclusively between two known ids (mode between). */
  between_after_message_id?: number;
  between_before_message_id?: number;
  mode?: "between";
};

export async function fetchChatMessages(
  params: FetchChatMessagesParams,
): Promise<MessageListRes> {
  return (await socketQuery(
    socketInstance(),
    "message_list",
    {
      // History pages must not seed pin bar (dedicated get_pinned_messages).
      pinned: false,
      pageSize: 40,
      ...params,
    },
    "message_list",
  )) as MessageListRes;
}
